import { BaseLayoutOptions } from '@services/MarppleShop/features/Core/service';
import { footer_links } from '@services/MarppleShop/renderApp/components/cells/Footer/constant.ts';
import { LayoutView } from '@services/MarppleShop/renderApp/components/cells/Layout/LayoutView.ts';
import { makeHomeScreenNavigate } from '@services/MarppleShop/shared/app/navigate.ts';
import { ButtonAction } from '@services/MarppleShop/shared/components/atoms/ButtonAction/ButtonAction.ts';
import { font } from '@services/MarppleShop/shared/typography';
import { getResizedImage100WebpUrl } from '@services/MarppleShop/shared/util/getResizedImageUrl.ts';
import { html, Page, View } from 'rune-ts';
import klass from './ErrorSuspendStore.module.scss';

export type ErrorSuspendStorePageData = {
  is_mobile: boolean;
  layout_options: BaseLayoutOptions;
};

export type ErrorSuspendStoreBodyViewData = {
  is_mobile: ErrorSuspendStorePageData['is_mobile'];
};

export class ErrorSuspendStoreBodyView extends View<ErrorSuspendStoreBodyViewData> {
  protected override template() {
    const { img, title, description } = this.getData();

    return html`
      <div class="${klass.page}">
        <div class="${klass.image}">
          <img src="${img}" alt="error_img" />
        </div>
        <div class="${klass.text}">
          <div class="${font('20_bold')}">${html.preventEscape(title)}</div>
          <div class="${klass.description} ${font('16_medium')}">${html.preventEscape(description)}</div>
        </div>
        ${new ButtonAction({
          label: ET('mps2::common::go_marppleshop'),
          href: `/${ET.lang}`,
          navigate: makeHomeScreenNavigate(),
          type: 'blue',
          size: 'large',
          fit: true,
        })}
      </div>
    `;
  }

  getData = () => {
    return {
      img: getResizedImage100WebpUrl(
        '//s3.marpple.co/files/u_2283830/2025/4/original/ee19493fcfbe285968ac327d4046fd63ea24f16e1.png',
        1000,
      ),
      title: ET('mps2::error::suspend_store::title'),
      description: ET('mps2::error::suspend_store::description'),
    };
  };
}

export class ErrorSuspendStorePage extends Page<ErrorSuspendStorePageData> {
  protected override template() {
    const { is_mobile, layout_options } = this.data;

    return html`
      <div>
        ${new LayoutView(
          {
            body: new ErrorSuspendStoreBodyView(this.data),
            footer_data: { ...footer_links, lang: ET.lang, is_mobile },
          },
          {
            ...layout_options,
          },
        )}
      </div>
    `;
  }
}
